import { ReservationVoucher } from '../pb/index.js';
export class ReservationVoucherRecord {
    domain = 'libp2p-relay-rsvp';
    codec = new Uint8Array([0x03, 0x02]);
    relay;
    peer;
    expiration;
    constructor({ relay, peer, expiration }) {
        this.relay = relay;
        this.peer = peer;
        this.expiration = expiration;
    }
    marshal() {
        return ReservationVoucher.encode({
            relay: this.relay.toBytes(),
            peer: this.peer.toBytes(),
            expiration: BigInt(this.expiration)
        });
    }
    equals(other) {
        if (!(other instanceof ReservationVoucherRecord)) {
            return false;
        }
        if (!this.peer.equals(other.peer)) {
            return false;
        }
        if (!this.relay.equals(other.relay)) {
            return false;
        }
        if (this.expiration !== other.expiration) {
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=reservation-voucher.js.map